import angular from "angular";
import { importFilesUnderPath, templateCacheGenerator } from "roblox-es6-migration-helper";

import "../../../css/gameBadges.scss";

let templateContext = require.context("./components/templates/", true, /\.html$/);
let templates = templateCacheGenerator(angular, "gameBadgesTemplates", templateContext);

import gameBadgesModule from "./gameBadgesModule";
importFilesUnderPath(require.context("./constants/", true, /\.js$/));
importFilesUnderPath(require.context("./services/", true, /\.js$/));
importFilesUnderPath(require.context("./controllers/", true, /\.js$/));
importFilesUnderPath(require.context("./components/", true, /\.js$/));

// self manual initialization
angular.element(function () {
    angular.bootstrap("#game-badges-container", [gameBadgesModule.name]);
});

export default gameBadgesModule;